export default __webpack_public_path__ + "media/91b199b88cd9e91165928cdd8ac365726e2dea3e5cd9388994f7c75934f958ea.svg";